import {
  processingSessionIdFormat,
  processingSessionItemIdFormat,
} from "@redotech/redo-return-id";
import * as z from "zod";
import { ProcessingSession } from "./processing-session";

export const recordSessionItemAsReceived = {
  name: "recordSessionItemAsReceived" as const,
  input: z.object({
    sessionId: processingSessionIdFormat.schema,
    sessionItemId: processingSessionItemIdFormat.schema,
  }),
  output: z.object({ session: ProcessingSession }),
};
